module.exports = __webpack_public_path__ + "videos/animationassist-jp.fcd849e.mp4";